import { Paper } from '@mui/material';

interface MetriaPaperProps {
  style?: React.CSSProperties;
  className?: string;
}

export const FsokPaper: React.FC<MetriaPaperProps> = ({
  children,
  style,
  className,
}) => (
  <Paper
    sx={{
      boxShadow:
        '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)',
      borderRadius: '4px',
      border: '1px solid #ddd',
      ...style,
    }}
    className={className}
  >
    {children}
  </Paper>
);
